export type { ConfirmDialogProps } from './ConfirmDialog.types'
export { default as ConfirmDialog } from './ConfirmDialog'